import { getUniqueKey } from '@okee-uikit/react-utils';
var ELEMENT_MAP = {};

function createEventHandlerInfo(element, type) {
  var passive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var capture = /(capture:)/.test(type);
  var realType = capture ? type.slice(RegExp.$1.length) : type;
  var info = {
    passive: passive,
    setup: function setup() {
      info.element.addEventListener(realType, info.handler, {
        capture: capture,
        passive: passive
      });
    },
    teardown: function teardown() {
      info.element.removeEventListener(realType, info.handler, capture);
    },
    element: element,
    handler: function handler(e) {
      info.events.forEach(function (item) {
        item.call(info.element, e);
      });
    },
    events: []
  };
  return info;
}

export function addEventListener(element, type, listener) {
  var passive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var key = getUniqueKey(element);
  var info = ELEMENT_MAP[key] = ELEMENT_MAP[key] || {};
  var handlerInfo = info[type] = info[type] || createEventHandlerInfo(element, type, passive);
  var needSetup = handlerInfo.events.length === 0;
  handlerInfo.events.push(listener);

  if (needSetup) {
    handlerInfo.setup();
  }
}
export function removeEventListener(element, type, listener) {
  var key = getUniqueKey(element);
  var info = ELEMENT_MAP[key];

  if (info == null) {
    return;
  }

  if (type == null) {
    Object.keys(info).forEach(function (k) {
      removeEventListener(element, k, listener);
    });
    return;
  }

  var handlerInfo = info[type];

  if (handlerInfo == null) {
    return;
  }

  if (listener) {
    var index = handlerInfo.events.indexOf(listener);

    if (index >= 0) {
      handlerInfo.events.splice(index, 1);
    }
  } else {
    handlerInfo.events = [];
  }

  if (handlerInfo.events.length === 0) {
    handlerInfo.teardown();
    delete info[type];
  }

  if (Object.keys(info).length === 0) {
    delete ELEMENT_MAP[key];
  }
}